import React from "react";

import SBEditable from "../../../components/sbEditable/sbEditable";
import GetComponentsFromBloks from "../../../helpers/bloksRenderer";

import styles from "./richTextDataDefinitionList.module.scss";

function RichTextDataDefinitionList({ blok }) {
  return (
    <SBEditable blok={blok} key={blok._uid} withClass={styles.root}>
      <dl>
        {GetComponentsFromBloks(blok.items)}
      </dl>
    </SBEditable>
  );
}

export default RichTextDataDefinitionList;
